var burgerBtn = document.getElementById('burgerBtn');
var mobile = document.getElementById('mobile');
var body = document.getElementsByTagName('body')[0];
var demo1 = document.getElementById('demo1');
var demo2 = document.getElementById('demo2');
var demo3 = document.getElementById('demo3');

/* burgerBtn.addEventListener('click', function () {
  mobile.classList.toggle('navigation');
  body.classList.toggle('navigation');
}, false); */

jQuery(function ($) {

  //Sidebar Menu Collapse
  if ($('.widget-area .widget_nav_menu').length > 1) {
    let $widgetMenu = $('.widget-area .widget_nav_menu').find('.menu .current-menu-item');
    let $widgetParentMenu = $('.widget-area .widget_nav_menu').find('.menu .current-menu-parent');
    if ($widgetMenu.length > 0) {
      $widgetMenu.addClass('showing-submenu')
      $widgetMenu.find('.sub-menu').addClass('show-submenu')
    }
    if ($widgetParentMenu.length > 0) {
      $widgetParentMenu.addClass('showing-submenu')
      $widgetParentMenu.find('.sub-menu').addClass('show-submenu')
    }
    let $widgetSubMenu = $('.widget-area .widget_nav_menu .menu .menu-item').find('.sub-menu');
    if ($widgetSubMenu.length > 0) {
      $('.widget-area .widget_nav_menu .menu .menu-item:not(.showing-submenu)').hover(function () {
        $(this).find('.sub-menu').toggleClass('show-submenu');
      })
    }

  }



  //Stretch Title Bar
  var stretched_col_calc = function () {

    //console.log('Calc starts....');
    // padding left or right
    if (jQuery('.title-bar-wrapper').length > 0) {

      // Returns width of browser viewport
      var window_width = jQuery(window).width();

      // Returns width of HTML document
      var document_width = jQuery(document).width();

      jQuery('.title-bar-wrapper').each(function () {

        var this_ele = jQuery(this);
        var curr_width = jQuery(this).closest('.container').width();
        var extra_width = ((window_width - curr_width) / 2);

        /*console.log('ele: ', this_ele);
        console.log('curr_width: ', curr_width);
        console.log('extra_width: ', extra_width);*/

        position = 'right'

        jQuery(jQuery(this)).css('margin-' + position, '-' + extra_width + 'px');

      });
    }

  }//mainFunction

  stretched_col_calc();


  /*
  Sterch Overlay
   */
  var stretched_overlay_calc = function () {

    if (jQuery('.stretched-overlay .elementor-background-overlay').length > 0) {

      // Returns width of browser viewport
      var window_width = jQuery(window).width();

      // Returns width of HTML document
      var document_width = jQuery(document).width();
      var container_width = jQuery('#content').width();
      console.log('container_width: ', container_width);
      console.log(jQuery(this));
      /* if(jQuery('.stretched-overlay').hasClass('stretched-overlay-40')){
           var container_width = jQuery( '#content' ).width() + 40;
           console.log('container_width+40: ', container_width);
       }*/

      jQuery('.stretched-overlay .elementor-background-overlay').each(function () {



        var this_ele = jQuery(this);
        var curr_width = jQuery(this).closest('.elementor-section').width();
        var extra_width = ((window_width - container_width) / 2);

        /*console.log('ele: ', this_ele);
        console.log('sect_width: ', curr_width);
        console.log('overaly_width: ', extra_width);*/

        position = 'right'

        //jQuery(jQuery(this)).css( 'margin-'+position,'-'+extra_width+'px' );
        if (jQuery('.stretched-overlay').hasClass('stretched-overlay-40')) {
          jQuery(jQuery(this)).css('width', extra_width + curr_width + 40 + 'px');
        } else {
          jQuery(jQuery(this)).css('width', extra_width + curr_width + 'px');
        }


      });
    }

  }
  stretched_overlay_calc()


  var tstk_stretched_col_calc = function () {
    //console.log('starting....')
    // padding left or right
    if (jQuery('.elementor-section > .elementor-container > .elementor-column.tstk-col-stretched-yes').length > 0) {

      //console.log('Yes, found streched class column')

      // Returns width of browser viewport
      var window_width = jQuery(window).width();

      // Returns width of HTML document
      var document_width = jQuery(document).width();
      var container_width = jQuery('#content').width();

      jQuery('.elementor-section > .elementor-container > .elementor-column.tstk-col-stretched-yes').each(function () {

        var this_ele = jQuery(this);
        var curr_width = jQuery(this).closest('.elementor-container').width();
        var extra_width = ((window_width - container_width) / 2);

        var position = 'left';
        if (jQuery(this).hasClass('tstk-col-stretched-right')) {
          position = 'right';
        }

        jQuery('.tstk-stretched-div', jQuery(this)).css('margin-' + position, '-' + extra_width + 'px');

        // stretched column content too
        if (jQuery(this).hasClass('tstk-col-stretched-content-yes')) {
          var stretched_width = jQuery('.tstk-stretched-div', jQuery(this)).width();
          jQuery(this).children('.elementor-column-wrap').css('margin-' + position, '-' + extra_width + 'px');
          jQuery(this).children('.elementor-column-wrap').css('width', stretched_width + 'px');
        } else {
          jQuery(this).children('.elementor-column-wrap').css('margin-' + position, '');
          jQuery(this).children('.elementor-column-wrap').css('width', '');
        }
      });
    }

  }
  tstk_stretched_col_calc()


  /*
  Stretch Section
   */

  /*
  Sterch Overlay
   */
  var stretched_section = function () {

    if (jQuery('.stretched-section').length > 0) {

      // Returns width of browser viewport
      var window_width = jQuery(window).width();

      // Returns width of HTML document
      var document_width = jQuery(document).width();
      var container_width = jQuery('#content').width();
      console.log('container_width: ', container_width);
      console.log(jQuery(this));
      /* if(jQuery('.stretched-overlay').hasClass('stretched-overlay-40')){
           var container_width = jQuery( '#content' ).width() + 40;
           console.log('container_width+40: ', container_width);
       }*/

      jQuery('.stretched-section').each(function () {



        var this_ele = jQuery(this);
        var curr_width = jQuery(this).width();
        var extra_width = ((window_width - container_width) / 2);

        /*console.log('ele: ', this_ele);
        console.log('sect_width: ', curr_width);
        console.log('overaly_width: ', extra_width);*/

        position = 'right'

        //jQuery(jQuery(this)).css( 'margin-'+position,'-'+extra_width+'px' );

        jQuery(jQuery(this)).css('width', extra_width + 'px');


      });
    }

  }
  //stretched_section()







  jQuery(window).resize(function () {
    setTimeout(function () {
      stretched_col_calc();
      stretched_overlay_calc();
      tstk_stretched_col_calc();
      //stretched_section();
    }, 100);
  });






  /*
  Add Streched Div dynamically
   */

  jQuery('.elementor-section.tstk-col-stretched-yes').each(function () {

    var ThisSection = jQuery(this);
    var ThisColumn = '';
    var ColWrapper = '';
    var StretchedEle = '';


    if (ThisSection.hasClass('tstk-col-stretched-right') || ThisSection.hasClass('tstk-col-stretched-both')) {
      ThisColumn = jQuery('.elementor-column:not(.elementor-inner-column):last-child', ThisSection);

      // console.log('Searching for streched div....', ThisColumn)

      if (jQuery('.tstk-stretched-div', ThisColumn).length == 0) {
        ColWrapper = ThisColumn.children('.elementor-element-populated');
        ColWrapper.prepend('<div class="tstk-stretched-div"></div>');
        //ThisColumn.prepend( '<div class="tstk-stretched-div"></div>' );

        // Stretched Element
        StretchedEle = ColWrapper.children('.tstk-stretched-div');
        //StretchedEle = ThisColumn.children('.tstk-stretched-div');

        StretchedEle.addClass('tstk-stretched-right');
        ThisColumn.addClass('tstk-col-stretched-yes tstk-col-stretched-right');

        if (ThisSection.hasClass('tstk-right-col-stretched-content-yes')) {
          ThisColumn.addClass('tstk-col-stretched-content-yes');
        } else {
          ThisColumn.removeClass('tstk-col-stretched-content-yes');
        }

        // background move to stretched div
        ColWrapper.css('background-image', '');
        var bgImage = ColWrapper.css('background-image');
        if (bgImage != 'none' && bgImage != '') {
          StretchedEle.css('background-image', bgImage);
          ColWrapper.css('background-image', 'none');
        }

        // border radious
        ColWrapper.css('border-top-left-radius', '');
        ColWrapper.css('border-top-right-radius', '');
        ColWrapper.css('border-bottom-left-radius', '');
        ColWrapper.css('border-bottom-right-radius', '');
        var radius_t_left = ColWrapper.css('border-top-left-radius');
        var radius_t_right = ColWrapper.css('border-top-right-radius');
        var radius_b_left = ColWrapper.css('border-bottom-left-radius');
        var radius_b_right = ColWrapper.css('border-bottom-right-radius');
        if (radius_t_left != '0' && radius_t_left != '') {
          StretchedEle.css('border-top-left-radius', radius_t_left);
          ColWrapper.css('border-top-left-radius', '0');
        }
        if (radius_t_right != '0' && radius_t_right != '') {
          StretchedEle.css('border-top-right-radius', radius_t_right);
          ColWrapper.css('border-top-right-radius', '0');
        }
        if (radius_b_left != '0' && radius_b_left != '') {
          StretchedEle.css('border-bottom-left-radius', radius_b_left);
          ColWrapper.css('border-bottom-left-radius', '0');
        }
        if (radius_b_right != '0' && radius_b_right != '') {
          StretchedEle.css('border-bottom-right-radius', radius_b_right);
          ColWrapper.css('border-bottom-right-radius', '0');
        }

        // Background Color
        var bgColor = ColWrapper.css('background-color');
        if (bgColor != '') {
          StretchedEle.css('background-color', bgColor);
          ColWrapper.css('background-color', 'transparent');
        }

        // Background Position
        var bgPosition = ColWrapper.css('background-position');
        if (bgPosition != '') {
          StretchedEle.css('background-position', bgPosition);
        }

        // Background Repeat
        var bgRepeat = ColWrapper.css('background-repeat');
        if (bgRepeat != '') {
          StretchedEle.css('background-repeat', bgRepeat);
        }

        // Background Size
        var bgSize = ColWrapper.css('background-size');
        if (bgSize != '') {
          StretchedEle.css('background-size', bgSize);
        }

        tstk_stretched_col_calc();

      }
    }

  });




  //$('.menu-item-has-children > a').attr('href', '#');



})//main


console.clear()

//const navExpand = [].slice.call(document.querySelectorAll('#mobile-menu-primary .menu-item-has-children'))

/* navExpand.forEach(item => {
  item.querySelector('.nav-link').addEventListener('click', () => item.classList.add('active'))
  item.querySelector('.nav-back-link').addEventListener('click', () => item.classList.remove('active'))
})
 */

// ---------------------------------------
// not-so-important stuff starts here

const ham = document.getElementById('page-open-mobile-menu')
const closeIn = document.getElementById('page-close-mobile-menu')
ham.addEventListener('click', function () {
  document.body.classList.toggle('nav-is-toggled')
})
closeIn.addEventListener('click', function () {
  document.body.classList.toggle('nav-is-toggled')
})

jQuery(function ($) {

  const navToExpand = $('#mobile-menu-primary .menu-item-has-children');
  navToExpand.each(function (idx, li) {
    var item = $(li);
    item.find('.nav-link').on('click', function (e) {
      item.addClass('active');
    })
    item.find('.nav-link.nav-back-link').on('click', function (e) {
      e.preventDefault();
      $(this).parent().parent().parent().removeClass('active');
    })
  });


})